import React, { useState } from "react"
import { AccordionItem, MobileLink } from "."

const LINKS = [
  {
    label: "Profil",
    slug: "/dashboard/profil",
  },
  {
    label: "Daftar Pembelian",
    slug: "/dashboard/order",
  },
  // {
  //   label: "Referral Program",
  //   slug: "/dashboard/referral",
  // },
  {
    label: "Kelas Video Course",
    slug: "/learning/dashboard/progress",
  },
]

export const AccountAccordion = () => {
  const [accountOpen, setAccountOpen] = useState(false)

  return (
    <AccordionItem
      title="Akun"
      open={accountOpen}
      onToggle={() => setAccountOpen((current) => !current)}
    >
      {LINKS.map((link, i) => (
        <MobileLink link={link.slug} key={i}>{link.label}</MobileLink>
      ))}
    </AccordionItem>
  )
}
